import React, { useState, useContext } from "react";
import { Helmet } from "react-helmet";
import Api from "../../../../services/ServiceApi";
import GoBack from "../../../utility/goback";
import { BadgePill } from "../../../badge_pill/badge_pill";
import DynamicButton from "../../../../pages/uih/wf_controllers/BtnController/ButtonController";
import { Button, notification } from "antd";
import moment from "moment";
import { authUserContext } from "../../../../contexts/authContext";

//? nmc , ccare, m&m, admin
const teamEnableGenSap = ["101", "119", "102", "123", "120"];

const Cover = ({
  CompanyId,
  OperatorId,
  ProjectId,
  ProjectData,
  language,
  factupdate,
  Jobno,
  jobStatusName,
  jobTypeName,
  jobPriority,
  Jobdetail,
  Jobdata,
  workflow,
}) => {
  const authUserValue = useContext(authUserContext);
  const [isLoadingReGenSap, setIsLoadingReGenSap] = useState(false);

  const priority_name = jobPriority?.result_job_detail[0]?.priority_name || `-`;
  const { priority_status_bgcolor, priority_status_color } =
    jobPriority?.result_job_detail[0] ?? null;

  const handleReGenSap = () => {
    setIsLoadingReGenSap(true);
    Api.post("job_detail/genSapNo", {
      company_id: Jobdetail.company_id,
      operator_id: Jobdetail.operator_id,
      project_id: Jobdetail.project_id,
      job_id: Jobdetail.job_id,
      siteAreaCode: "",
      GenSapAll: "0",
      isYear: moment().year(),
      isMonth: moment().month() + 1,
      isDay: 0,
    })
      .then(({ data }) => {
        console.log(data);
        setIsLoadingReGenSap(false);
        if (data.result.code === "P" || data.result.value === "P") {
          notification.success({
            message: "Success",
            description: "Generate เลข SAP สำเร็จ",
          });
          setTimeout(() => {
            window.location.reload();
          }, 800);
        } else {
          notification.error({
            message: "Error",
            description: data.result.showText,
          });
        }
      })
      .catch((err) => {
        setIsLoadingReGenSap(false);
        notification.error({
          message: "Error",
          description: err.message,
        });
      });
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {ProjectData[0].project_name} / {Jobno}
        </title>
      </Helmet>
      <div className="d-flex justify-content-between mb-2">
        <GoBack className="c-white"></GoBack>
        <span className="c-white">{`Ma list > Full Detail`}</span>
      </div>
      <div className="row job-header">
        <div className="col col-12 col-md-6">
          <div className="d-flex align-items-start">
            <img
              src={`${Api.absoluteUrl("/icon/bbtec/header/Location.svg")}`}
              alt={Jobdata.result_job_detail[0]?.asset_code || null}
              title={Jobdata.result_job_detail[0]?.asset_code || null}
            />
            <div>
              <h2>
                {ProjectData[0].project_name} / {Jobno}
              </h2>
              <h3>
                {Jobdata.result_job_detail[0]?.so_id || "-"} /{" "}
                {Jobdata.result_job_detail[0]?.asset_code || "-"} /{" "}
                {Jobdata.result_job_detail[0]?.location_name || "-"}
              </h3>
              <BadgePill
                bgColor={priority_status_bgcolor}
                color={priority_status_color}
                text={priority_name}
              ></BadgePill>
              <BadgePill
                bgColor="#fff"
                color="#000"
                text={jobTypeName}
              ></BadgePill>
              <BadgePill
                bgColor="#fff"
                color="#000"
                text={jobStatusName}
              ></BadgePill>
              <div style={{ display: "flex", marginTop: 10 }}>
                <span style={{ fontSize: 20, color: "white" }}>
                  SCCD Ticket Status :
                </span>
                <span
                  style={{ fontSize: 20, color: "#e8cd00", marginLeft: 10 }}
                >
                  {Jobdetail.ticketStatus || 'N/A'}
                </span>
                <span style={{ fontSize: 20, color: "white", marginLeft: 20 }}>
                  SCCD Activity Status :
                </span>
                <span
                  style={{ fontSize: 20, color: "#e8cd00", marginLeft: 10 }}
                >
                  {Jobdetail.activityStatus || 'N/A'}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="col col-12 col-md-6">
          <div className="d-flex align-items-end flex-column">
            {
              !+Jobdetail.sap_id && (
                <div className="d-flex justify-content-start justify-content-md-end flex-wrap button-header p-md-2 py-3">
                  <Button
                    loading={isLoadingReGenSap}
                    onClick={() => handleReGenSap()}
                  >
                    ReGenSAP
                  </Button>
                </div>
              )
              // )
            }

            <DynamicButton
              CompanyId={CompanyId}
              OperatorId={OperatorId}
              ProjectId={ProjectId}
              workflow={workflow}
              page={"full_detail_job"}
              wrapClassName={
                "d-flex justify-content-start justify-content-md-end flex-wrap button-header p-md-2 py-3"
              }
              Jobdetail={Jobdetail}
              Jobdata={Jobdata}
              language={language}
              factupdate={factupdate}
            ></DynamicButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default Cover;
